// API
import { fetchUniversityDetails } from "@/api";

// Actions
import { setIsLoading, showToasterMessage } from "@/store/actions/commonActions";
import { deserializeUniversityDetails } from "@/utils/deserializers/universityDetailsDeserializer";
import { goToRoute } from "./navigationActions";

// Constants
export const INITIALIZE_UNIVERSITY_DETAILS = "INITIALIZE_UNIVERSITY_DETAILS";
export const ACCESS_TYPE = {
    counsellor: "counsellor",
    university: "university",
};

// Utils
import routePaths from "@/utils/route-paths";
export const initializeUniversityDetails = (payload) => {
    return {
        type: INITIALIZE_UNIVERSITY_DETAILS,
        payload,
    };
};

export const universityDetailsGetAndStore = (data, callback = null) => {
    return (dispatch) => {
        fetchUniversityDetails(data)
            .then((res) => {
                dispatch(initializeUniversityDetails(deserializeUniversityDetails(res.data)));
                if (callback) {
                    callback(res.data);
                } else dispatch(setIsLoading(false));
            })
            .catch((err) => {
                dispatch(setIsLoading(false));
                dispatch(showToasterMessage("Session Expired!", "error"));
                dispatch(goToRoute(routePaths.UNIVERSITY_LOGIN));
                console.log(err);
            });
    };
};
